import classes from './SidebarFooter.module.css'
import { ReactComponent as Chat } from '../../../../assets/circle.svg';
import useBotsService from '../../../../services/bot/botService';
import { useDispatch, useSelector } from 'react-redux';
import { toggle } from '../sidebarSlice'

function SidebarFooter() {
    const botService = useBotsService()
    const isMobile = useSelector(state => state.layout).isMobile
    const dispatch = useDispatch()    

    const newConversationHandler = async () => { 
        await botService.newSession()
        if (isMobile) {
            dispatch(toggle({isOpen: false}))
        }
    }

    return (
        <div className={classes.SidebarFooter}>
            <div className={classes.Button} onClick={newConversationHandler}>
                <div style={{marginRight: "5px"}}>שיחה חדשה</div>
                <Chat/>
            </div>
        </div>
    );
}

export default SidebarFooter;
